module.exports = __webpack_public_path__ + "img/Lumina_round.a8112508.png";